import { useForm } from "react-hook-form";
import { useAuth } from "../../providers/auth";
import FindPassword from "./FindPassword";
import { useState } from "react";
import { toast } from "react-toastify";
import {
  OnedaybiotechLoginLogo,
  PasswordIcon,
  UsernameIcon,
  LoginChecklist,
} from "../../assets/img";
import { useNavigate } from "react-router-dom";
import Modal from "../../components/ui/Modal/Modal";

function Login() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { login } = useAuth();
  const [findPassword, setFindPassword] = useState(false);
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const onSubmit = async (data) => {
    try {
      const res = await login({
        username: data.username,
        password: data.password,
      });
      if (res?.ok === true) {
        localStorage.setItem("currentMenu", "/");
        localStorage.removeItem("currentSubMenu");
        navigate("/");
      }
    } catch (error) {
      setIsError(true);
    }
  };

  const handleChecklist = () => {
    setChecked(!checked);
  };

  const handleFindPassword = () => {
    setFindPassword(true);
  };

  return (
    <div className="bg-primary-blue">
      {findPassword ? (
        <>
          <FindPassword />
        </>
      ) : (
        <div className=" flex-row justify-center max-w-xl m-auto px-6 md:px-20 pt-44 h-screen overflow-hidden">
          <div className="flex justify-center">
            <img className="w-[11.5rem]" src={OnedaybiotechLoginLogo} alt="" />
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex justify-center">
              <div className="mt-16 w-[20rem]">
                <div className="mb-4 flex bg-white border rounded-[4px] h-[42px] items-center">
                  <img src={UsernameIcon} className="w-8 h-8 ml-4" alt="" />
                  <input
                    type="text"
                    id="username"
                    placeholder="아이디"
                    className="block w-full placeholder:text-[#c7c7c7] mb-2 outline-none h-10 px-2 py-2 mt-2 text-secondary-500 bg-white rounded-lg"
                    {...register("username", { required: true })}
                  />
                </div>
                {errors.username && errors.username.type === "required" && (
                  <p className="text-red-500 mb-4">아이디를 입력해주세요.</p>
                )}
                <div className="mb-4 flex bg-white border rounded-[4px] h-[42px] items-center">
                  <img src={PasswordIcon} className="w-8 h-8 ml-4" alt="" />
                  <input
                    type="password"
                    id="password"
                    placeholder="비밀번호"
                    className="block w-full mb-3 outline-none placeholder:text-[#c7c7c7] h-8 px-2 py-2 mt-2 text-secondary-500 bg-white rounded-lg"
                    {...register("password", { required: true })}
                  />
                </div>
                {errors.password && errors.password.type === "required" && (
                  <p className="text-red-500 mb-4">비밀번호를 입력해주세요.</p>
                )}
              </div>
            </div>
            <div className="flex justify-between mx-12 text-white">
              <div className="flex">
                {checked ? (
                  <img
                    onClick={handleChecklist}
                    src={LoginChecklist}
                    className="mr-2 w-[13px] cursor-pointer"
                    alt=""
                  />
                ) : (
                  <input
                    onClick={handleChecklist}
                    type="checkbox"
                    className="accent-drop-yellow mr-2 cursor-pointer"
                  />
                )}

                <p className="text-secondary-grey">로그인 상태 유지</p>
              </div>
              <div
                onClick={handleFindPassword}
                className="text-drop-yellow cursor-pointer underline"
              >
                ID/PW 찾기
              </div>
            </div>
            <div className="mx-12 mt-6">
              <button
                type="submit"
                value="Login"
                className="bg-drop-yellow text-[14px] text-primary-blue w-full py-3 rounded-[4px]"
              >
                로그인
              </button>
            </div>
          </form>
          <div className="text-primary-grey mt-32 text-[10px] text-center">
            Copyright(C) ONEDAYBIOTECH, All rights reserved.
          </div>
        </div>
      )}
      {isError && (
        <Modal
          isOpenFromOutside={isError}
          setIsOpenFromOutside={setIsError}
          description={
            <span>
              일치하는 정보가 없습니다. 다시 입력해주세요.
              <br />
              자세한 문의는 관리자에게 해주시기바랍니다.
            </span>
          }
          hasCancel={false}
        />
      )}
    </div>
  );
}

export default Login;
